export const DEFAULT_API_URL = './openapi/product-v1.yaml';

export const EXAMPLE_SPECS = [
  {
    text: 'Product API v1',
    value: './openapi/product-v1.yaml',
  },
  {
    text: 'Offer API v1',
    value: './openapi/offer-v1.yaml',
  },
  {
    text: 'Order API v1',
    value: './openapi/order-v1.yaml',
  },
  {
    text: 'Workflow API v1',
    value: './openapi/workflow-v1.yaml',
  },
  {
    text: 'Platform API v1',
    value: './openapi/platform-v1.yaml',
  }
];
